import * as Yup from 'yup'

export const CampaignSchema = Yup.object().shape({
  name: Yup.string().required('This field is required.'),
  start_date: Yup.date().required('Campaign start date is required.'),
  end_date: Yup.date()
    .required('Campaign end date is required.')
    .min(Yup.ref('start_date'), 'End date must be on or after start date.'),
  is_new_client: Yup.boolean(),
  client_id: Yup.number()
    .when('is_new_client', {
      is: false,
      then: () => Yup.number().integer().required('This field is required.'),
      otherwise: () => Yup.number().integer().notRequired()
    }),
  new_client_name: Yup.string()
    .when('is_new_client', {
      is: true,
      then: () => Yup.string().required('This field is required.'),
      otherwise: () => Yup.string().notRequired(),
    }),
  project_number: Yup.string().required('This field is required.'),
  gross_reach_target: Yup.number().integer("This value must be an integer").typeError('Must be a number'),
  influencer_target: Yup.number().integer("This value must be an integer").typeError('Must be a number'),
  influencer_budget: Yup.number().typeError('Must be a number'),
  social_budget: Yup.number().typeError('Must be a number'),
  media_budget: Yup.number().typeError('Must be a number'),
  travel_cost_target: Yup.number().nullable().typeError('Must be a number'),
  attendance_cost_target: Yup.number().nullable().typeError('Must be a number'),
  currency: Yup.string().required('This field is required.')
});
